// extracted by mini-css-extract-plugin
export default {"main":"ComponentsPage_main__z7KrS","tableWrapper":"ComponentsPage_tableWrapper__zw7Kx","componentSelected":"ComponentsPage_componentSelected__st5EP"};